var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-wrapper"},[_c('div',{staticClass:"avatar-circle"},[_c('div',{staticStyle:{"font-weight":"400","color":"rgb(255, 255, 255)"}},[_vm._v(_vm._s(_vm.firstChar))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }